export { default as buildMock } from './buildMock'
export * from './createSignature'
export * from './hooks'
export { default as uuid } from './id'
export { LazyRoute, lazyRoute } from './LazyRoute'
export { default as parser } from './Parser'
export * from './queryClient'
export { default as ChildrenSchema } from './schemas/ChildrenSchema'
export { default as Timer } from './Timer'

export const { format: formatMoney } = new Intl.NumberFormat('es-CO', {
  currency: 'COP',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
  style: 'currency',
})

export const naturalSort = (a: string, b: string) => {
  const sA = a || 'ZZZ'
  const sB = b || 'ZZZ'
  return sA.localeCompare(sB, 'es-CO', { numeric: !Number.isNaN(sA) && !Number.isNaN(sB) })
}

export const isBirthday2WeeksClose = (timestamp: number) => {
  const now = new Date()
  const date = new Date(timestamp)
  if (now.getFullYear() !== date.getFullYear()) {
    date.setFullYear(now.getFullYear()).valueOf()

    const twoWeeks = 1_209_600_000
    return date.valueOf() > now.valueOf() - twoWeeks && date.valueOf() < now.valueOf() + twoWeeks
  }

  return false
}
